import { Types } from "../types"
import { ErrorPayLoad } from "../types/common/commonTypes"
import { GetCustomerLatestCallsError, GetCustomerLatestCallsRequest, GetCustomerLatestCallsSuccess } from "../types/Dashboard/actionsType"





export const getCustomerLatestCallsRequestAction = (): GetCustomerLatestCallsRequest => ({
    type: Types.GET_LATEST_CALLS_REQUEST,
})

export const getCustomerLatestCallsSuccessAction = (response: any[]): GetCustomerLatestCallsSuccess => ({
    type: Types.GET_LATEST_CALLS_SUCCESS,
    response
})

export const getCustomerLatestCallsErrorAction = (payload: ErrorPayLoad): GetCustomerLatestCallsError => ({
    type: Types.GET_LATEST_CALLS_ERROR,
    payload
})
